export default __webpack_public_path__ + "static/media/ico_service.c8066315.svg";